import React from 'react';
import './verticalTimeline.css';

const VerticalTimeline = (props) => {
  const { data } = props;
  const items = data.map((item, index) => {
    const { title, body, background, link } = item;
    const __background = `url("${background}")`;
    let anchor, destination;
    if(link) {
      ({ anchor, destination } = link);
    }
    return(
      <TimelineItem
        key={index}
        index={index}
        title={title}
        body={body}
        backgroundImage={__background}
        linkAnchor={anchor}
        linkDestination={destination}
      />
    );
  });
  return <div className="vertical-timeline">{items}</div>;
}

const TimelineItem = (props) => {
  const {
    index,
    title,
    body,
    backgroundImage,
    linkAnchor,
    linkDestination
  } = props;
  const cls = `vertical-timeline--item ${index % 2 !== 0 ? 'right' : ''}`;
  return(
    <div className={cls}>
      <div className="vertical-timeline--badge"></div>
      <div className="vertical-timeline--content" style={{ backgroundImage }}>
        <h3>{title}</h3>
        <p>{body}</p>
        <a href={linkDestination} target="_blank" rel="noopener noreferrer">{linkAnchor}</a>
      </div>
    </div>
  );
}

export default VerticalTimeline;
